/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptAnalyticsListRequest {
    getFixupPrototypeFunction() { return PromptAnalyticsListRequest.fixupPrototype; }

    static newInstance(model: Partial<PromptAnalyticsListRequest>): PromptAnalyticsListRequest {
        let obj = Object.assign(new PromptAnalyticsListRequest(), model);
        PromptAnalyticsListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptAnalyticsListRequest>): PromptAnalyticsListRequest {
        if (!model) return null;
        return PromptAnalyticsListRequest.newInstance(<PromptAnalyticsListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptAnalyticsListRequest) {
        if (!obj) return;

        models.PromptAnalyticsListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptAnalyticsListRequest): boolean {
        Object.setPrototypeOf(obj, PromptAnalyticsListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AIGovernanceRequest.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.PromptAnalyticsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.PromptAnalyticsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AIGovernanceRequest;

}
